<template>
  <div class="msg">
      暂无消息
     <Tabbar :active="1"></Tabbar>
  </div>
</template>
<script>
import Tabbar from "@/components/Tabbar";
export default {
  components: { Tabbar },
}
</script>
<style lang="less" scoped>
.msg{
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: white;
  color: #818181;
  font-size: 30px;
  padding-top: 45%;
}
</style>



// WEBPACK FOOTER //
// src/views/msg/msg.vue